import React, { useContext, useEffect, useState } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
//@MUI
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Divider from '@mui/material/Divider'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import { Container } from '@mui/material'
import moment from 'moment'
import AnDatePicker from '../../../../components/DateTime/DatePicker'
import { EmployeeFormContext } from './EmployeeForm'
import API from '../../../../services/API'

const ProfessionalQuals = () => {
  const { formValues, setFormValues } = useContext(EmployeeFormContext)
  const [isHCP, setIsHCP] = useState(
    !!formValues?.employee?.registrationNumber?.number,
  )
  const [roles, setRoles] = useState([])
  useEffect(() => {
    API.get('/settings?select=roles').then(
      (res) => res.status === 200 && setRoles(res.data.roles),
    )
  }, [])
  return (
    <Paper sx={{ padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title">Professional Qualifications</Typography>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              label="Registered Healthcare Professional"
              control={
                <Checkbox
                  checked={isHCP}
                  onChange={(e) => {
                    setIsHCP(e.target.checked)
                    if (e.target.checked === false) {
                      setFormValues((prev) => ({
                        ...prev,
                        employee: {
                          ...prev.employee,
                          registrationNumber: {},
                        },
                      }))
                    }
                  }}
                />
              }
            />
          </Grid>
          {isHCP && (
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel id="hcp-label">Regulatory Body</InputLabel>
                <Select
                  labelId="hcp-label"
                  required={isHCP}
                  id="hcp-regbody"
                  value={formValues?.employee?.registrationNumber?.body ?? ''}
                  label="Regulatory Body"
                  onChange={(event) =>
                    setFormValues((prev) => ({
                      ...prev,
                      employee: {
                        ...prev.employee,
                        registrationNumber: {
                          ...prev.employee?.registrationNumber,
                          body: event.target.value,
                        },
                      },
                    }))
                  }
                >
                  <MenuItem value="hcpc">HCPC</MenuItem>
                  <MenuItem value="nmc">NMC</MenuItem>
                  <MenuItem value="gmc">GMC</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {isHCP && (
            <Grid item xs={12} md={4}>
              <TextField
                label="Registration Number"
                autoComplete="off"
                fullWidth
                value={formValues?.employee?.registrationNumber?.number ?? ''}
                onChange={(event) =>
                  setFormValues((prev) => ({
                    ...prev,
                    employee: {
                      ...prev.employee,
                      registrationNumber: {
                        ...prev.employee?.registrationNumber,
                        number: event.target.value,
                      },
                    },
                  }))
                }
              />
            </Grid>
          )}
          {isHCP && (
            <Grid item xs={12} md={4}>
              <AnDatePicker
                label="Renewal Date"
                date={moment(
                  formValues?.employee?.registrationNumber?.renewDate,
                )}
                fullWidth
                onChange={(newDate) =>
                  setFormValues((prev) => ({
                    ...prev,
                    employee: {
                      ...prev.employee,
                      registrationNumber: {
                        ...prev.employee?.registrationNumber,
                        renewDate: newDate,
                      },
                    },
                  }))
                }
              />
            </Grid>
          )}
        </Grid>
        <Divider sx={{ width: '100%', marginY: 2 }} />
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel id="hcp-label">Clinical Role</InputLabel>
            <Select
              labelId="clinicalrole-label"
              required
              id="clinical-role"
              value={
                (roles.length > 0 && formValues.employee?.clinicalRole) || ''
              }
              label="Clinical Role"
              onChange={(event) =>
                setFormValues((prev) => ({
                  ...prev,
                  employee: {
                    ...prev.employee,
                    clinicalRole: event.target.value,
                  },
                }))
              }
            >
              {roles &&
                roles.map((role, index) => (
                  <MenuItem key={index} value={role}>
                    {role}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default ProfessionalQuals
